function get() {
    let str = localStorage.getItem('user-config');
    if (!str) {
        return null;
    }
    return JSON.parse(str);
}

function set(data) {
    localStorage.setItem('user-config', JSON.stringify(data));
}

function getItem(key) {
    let config = get();
    if (!config) {
        return null;
    }
    let value = config[key];
    if (!value) {
        return null;
    }
    return value;
}

function setItem(key, value) {
    let config = get();
    if (!config) {
        config = {};
    }
    if (config[key] === value) {
        return;
    }
    config[key] = value;
    set(config);
}

export default {
    get, set, getItem, setItem
}
